import Comparator from './Comparator.component';
import TextModeComparator from './displayMode/TextMode.component';

export { TextModeComparator };
export default Comparator;
